module.exports = __webpack_public_path__ + "img/40_38_049_740.8b1cb0ae.jpg";